import { createSelector } from 'reselect';

import getLocalForage from './getLocalForage';
import getPersistedMenu from './getPersistedMenu';
import getPlatform, { PLATFORM } from '../utils/getPlatform';

const platform = getPlatform();

export default createSelector(
  [getLocalForage, getPersistedMenu, (_: any, saleType: SALE_TYPE) => saleType],
  (
    localForage: LocalForageState,
    persistedMenu,
    saleType,
  ):
    | {
        etag: string;
        menu?: [
          MenuNode,
          _Items,
          ChoiceSets,
          RedCat.UpsellChoiceSet[],
          string | undefined | null,
          CategoryInfo[],
          SubstitutionSets,
        ];
      }
    | undefined => {
    if (platform === PLATFORM.WEB) {
      if (localForage.cachedMenu) {
        return localForage.cachedMenu[saleType] || undefined;
      }
      return undefined;
    } else {
      if (persistedMenu) {
        return persistedMenu[saleType] || undefined;
      }
      return undefined;
    }
  },
);
